export enum OfisProUyarilar {
    tebligatUyarilari = 1,
    adresArastirmaYapilacaklar,
    barkodSorgusuVeTebligatBilgisi,
    dosyaninKesinlestirilmesiTalebi,
    gonderildigiTarihGirilecekler,
    hacizTalebindeBulunulacakDosyalar,
    itirazinIptaliKaldirilmasiDavasi,
    malBeyanindaBulunmamaDavasi,
    mernisAdresineTebligat,
    mersisAdresineTebligat,
    otuzBeseGoreTebligat,
    yirmiBireGoreTebligat,
    hacizUyarilari,
    haczeGidilecekDosyalar,
    hacizTarihiGirilecekDosyalar,
    seksenDokuzIkiIhbarnamesi,
    seksenDokuzUcIhbarnamesi,
    maasHacziMuzekkeresi,
    muzekkereTebligiKontrol,
    yuzUcDavetiyesi,
    kiymetTakdiriIstenecekler,
    islemsizliktenDusecekDosyalar,
}

export enum OfisProUyarilarLabel {
    "Tebligat Uyarıları" = 1,
    "Adres Araştırması Yapılacaklar",
    "Barkod Sorgusu Yapılacaklar ve Tebligat Bilgisi Girilecekler",
    "Dosyanın Kesinleştirilmesi Talebi Gönderilecekler",
    "Gönderildiği Tarih Girilecekler",
    "Haciz Talebinde Bulunulacak Dosyalar",
    "İtirazın İptali/Kaldırılması Davası Açılacak Dosyalar",
    "Mal Beyanında Bulunmama Sebebiyle Dava Açılacak Dosyalar",
    "Mernis Adresine Tebligat Yapılacak Dosyalar",
    "Mersis Adresine Tebligat Yapılacak Dosyalar",
    "35'e Göre Tebligat Talep Edilecek Dosyalar",
    "21'e Göre Tebligat Talep Edilecek Dosyalar",
    "Haciz Uyarıları",
    "Hacze Gidilecek Dosyalar",
    "Haciz Tarihi Girilecek Dosyalar",
    "89-2 İhbarnamesi Gönderilecekler",
    "89-3 İhbarnamesi Gönderilecekler",
    "Maaş Haczi Müzekkeresi Gönderilecekler",
    "Müzekkere Tebliği Kontrol Edilecekler",
    "103 Davetiyesi Gönderilecekler",
    "Kıymet Takdiri İstenecekler",
    "İşlemsizlikten Düşecek Dosyalar",
}
